import { TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import {
  screenSizeMap,
  ScreenSizeController,
} from '../../controllers/screen-size-controller';

/**
 * The SicSearch component
 * @element sic-search
 *
 * Lightdom styles in sic-search.lightdom.css included in /shared.css
 */
@customElement('sic-search')
export class SicSearch extends OutlineElement {
  screens = new ScreenSizeController(this);

  @property({ type: Boolean, attribute: 'trap-focus' })
  trapFocus = false;

  @property({ type: Boolean })
  isMobile: boolean = window.innerWidth < (screenSizeMap.get('lg') as number);
  /**
   * Exposes full component to light-DOM
   */
  protected createRenderRoot() {
    return this;
  }

  render(): TemplateResult {
    return html``;
  }

  updated() {
    if (this.trapFocus) {
      this.applyTrapHandler();
      this.applyCloseFocusHandler();
    }
  }
  applyTrapHandler() {
    const submitButton = this.querySelector('[aria-label="Perform search"]');
    if (submitButton) {
      // @ts-expect-error because-ts
      submitButton.addEventListener('keydown', this.trapHandler);
    }
  }

  applyCloseFocusHandler() {
    const header = document.querySelector('sic-main-header') as HTMLElement;
    const closeButton = header?.shadowRoot?.querySelector(
      '.sic-main-header--search-close-button'
    ) as HTMLButtonElement;
    if (closeButton) {
      closeButton.addEventListener('click', this.closeFocusHandler);
    }
  }

  trapHandler(e: KeyboardEvent) {
    const header = document.querySelector('sic-main-header') as HTMLElement;
    const closeButton = header?.shadowRoot?.querySelector(
      '.sic-main-header--search-close-button'
    ) as HTMLButtonElement;

    if (closeButton && e.key === 'Tab') {
      e.preventDefault();
      closeButton.focus();
    }
  }

  closeFocusHandler() {
    const header = document.querySelector('sic-main-header') as HTMLElement;
    const searchButton = header?.shadowRoot?.querySelector(
      '.sic-main-header--search-button'
    ) as HTMLElement;
    if (searchButton) {
      searchButton.focus();
    }
  }
}
